import { Component, EventEmitter, Input, Output } from '@angular/core'

import { Department } from '@app/features/scoping/models/department.model'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ScopeElementsService } from '../services/scope-elements.service'
import { UpdateRolePayload, ScopeElementsConfig } from '../models'
import { isPreferenceActive } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'

@Component({ selector: 'scope-departments-row', templateUrl: './departments-row.component.html' })
export class DepartmentsRowComponent {
  @Input() level: number
  @Input() component: ScopeComponent
  @Input() config: ScopeElementsConfig
  @Input() department: Department

  @Output() onOverrideRateCardRoleHours = new EventEmitter<UpdateRolePayload>()
  @Output() onUpdateRole = new EventEmitter<UpdateRolePayload>()

  constructor(protected scopeElementsService: ScopeElementsService) {}

  selectDepartment(departmentId: number) {
    this.scopeElementsService.toggleDepartment(departmentId)
  }

  protected readonly isPreferenceActive = isPreferenceActive
}
